import { graphql } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import React from "react";
import { Parallax } from "react-parallax";
import "./paraHeaderImg.scss";

export const ParagraphHeaderImage = ({ node }) => {
  if (!node?.relationships?.field_image?.url) return null;
  return (
    <div className="paragraph-header-img">
      {node?.relationships?.field_image?.gatsbyImage && (
        <>
          {node?.field_enable_parallax ? (
            <Parallax
              bgImage={node?.relationships?.field_image?.url} // path to the background image that makes parallax effect
              strength={500} // parallax effect strength (in pixel). this will define the amount of pixels the background image is translated
              bgImageStyle={{ height: 700 }} // set background image styling
            >
              <div className="parallax-container"></div>
            </Parallax>
          ) : (
            <div className="parallax-image">
              <GatsbyImage
                image={getImage(node?.relationships?.field_image?.gatsbyImage)}
                alt="banner-image"
              />
            </div>
          )}
        </>
      )}

      <div className="captions-wrapper fst-italic">
        {node?.field_image_caption && <p>{node?.field_image_caption}</p>}
        {node?.field_image_credit && <p>{node?.field_image_credit}</p>}
      </div>
    </div>
  );
};

export const fragment = graphql`
  fragment ParagraphParagraphHeaderImage on paragraph__paragraph_header_image {
    id
    relationships {
      field_image {
        url
        gatsbyImage(
          width: 2500
          # height: 750
          # aspectRatio: 1.77777
          # cropFocus: FACES
          # fit: CONTAIN
          quality: 100
          placeholder: BLURRED
          # transformOptions: { fit: "cover", cropFocus: "attention" }
          # layout: CONSTRAINED
          # layout: FULL_WIDTH
        )
      }
    }
    field_image_credit
    field_image_caption
    field_enable_parallax
  }
`;

export default ParagraphHeaderImage;
